export default __webpack_public_path__ + "static/media/sirrus.683e4e20.png";